import { useEffect, useState } from 'react';
import { isOnline, subscribeToNetwork } from 'src/utils/network-service';

export default function useNetworkStatus() {
  const [online, setOnline] = useState(isOnline());

  useEffect(() => {
    // Subscribe to network changes
    const unsubscribe = subscribeToNetwork((status) => {
      setOnline(status);
    });

    return unsubscribe;
  }, []);

  return online;
}
